export const distance = (a, b) => b-a

export const getRangeRatio = (from, to, ratio) => (ratio-from) / (to-from)

export const interpolate = (from, to, ratio) => from + distance(from, to) * ratio

export const interpolateVector = (from, to, ratio) => ({
  x:interpolate(from.x, to.x, ratio),
  y:interpolate(from.y, to.y, ratio),
  z:interpolate(from.z, to.z, ratio)
})


// WEBPACK FOOTER //
// ./src/scripts/helpers/MotionHelper.js